module.exports = __webpack_public_path__ + "img/content5-1.52fa004a.webp";